module.exports = __webpack_public_path__ + "img/4.78885fe4.jpeg";